import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { FiCheck } from "@react-icons/all-files/fi/FiCheck";
import { FiCopy } from "@react-icons/all-files/fi/FiCopy";
import useShareImage from "../../hooks/useShareImage";
import SharePreview from "../SharePreview/SharePreview";
const campaignCaption = "Hi everyone, I'm sharing this Chuffed campaign because I think it matters. "
    + "Whether you can donate or just share it with others, it helps. Scan the QR code or click "
    + "the link in my bio to check it out.";
const updateCaption = "Hi everyone, here's an update on this Chuffed campaign I'm following. "
    + "Take a look, and feel free to share it or donate to the campaign if it resonates. "
    + "Scan the QR code for the full story.";
function PostShare({ shareItem, canNativeShare, isMobileDevice, type, buildShareData, }) {
    const [copied, setCopied] = useState(false);
    const shareUrlObject = new URL(shareItem.url);
    shareUrlObject.searchParams.set("utm_medium", "instagram-post");
    const shareUrl = shareUrlObject.toString();
    const { imageSrc, imageBlob, imageError, downloadImage, } = useShareImage({
        shareItem,
        shareUrl,
        showQrCode: true,
        isPost: true,
    });
    const canAutoShare = canNativeShare && isMobileDevice;
    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    const caption = type === "campaign" ? campaignCaption : updateCaption;
    useEffect(() => {
        var _a;
        // Wait for the image so the share sheet can include it - this effect re-runs once
        // imageBlob is set, at which point buildShareData() will have a file to attach.
        if (!canAutoShare || !imageBlob) {
            return;
        }
        (_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(caption);
        navigator.share(buildShareData(shareUrl, imageBlob)).catch(() => { });
    }, [canAutoShare, imageBlob, caption, shareUrl, buildShareData]);
    return (_jsxs("div", { className: "share-modal__instagram-post-content", children: [_jsx(SharePreview, { imageSrc: imageSrc, imageError: imageError, onDownload: downloadImage }), _jsx("h4", { className: "share-modal__instagram-title", children: "Ready to share with your Instagram community" }), _jsx("p", { className: "share-modal__instagram-description", children: "We've created an image and caption for your post, paste them into Instagram whenever you're ready." }), _jsx(CopyToClipboard, { text: caption, onCopy: handleCopy, children: _jsxs("div", { className: "share-modal__instagram-codeblock", children: [_jsx("p", { className: "share-modal__instagram-codeblock-text", "data-testid": "copy-instagram-caption", children: caption }), copied
                            ? _jsx(FiCheck, { className: "share-modal__copy-icon--copied" })
                            : _jsx(FiCopy, { className: "share-modal__copy-icon" })] }) }), canAutoShare && (_jsx("p", { className: "share-modal__instagram-footer", children: _jsx("button", { type: "button", className: "share-modal__instagram-footer-link", onClick: () => navigator.share(buildShareData(shareUrl, imageBlob)).catch(() => { }), children: "Click here if Instagram doesn't open automatically" }) }))] }));
}
export default PostShare;
